<template>
  <div class="tw:mt-4 tw:flex tw:flex-wrap tw:lg:gap-y-0 tw:items-stretch tw:-mr-4 tw:pr-4">
    <CampaignStatusCard
      class="tw:w-full tw:lg:w-1/3 tw:flex-shrink-0"
      :campaignType="campaignType"
      :unavailabilityRate="unavailabilityRate"
      :partnerStatus="partnerStatus"
      :campaignStatus="status"
      :budgetPercentage="budgetPercentage"
      :isActionable="false"
      :hasHint="false"
      :isSmall="true"
    />

    <ConnectivityProviderCard
      class="tw:w-full tw:lg:w-1/3 tw:flex-shrink-0"
      :currentPartner="currentRCPartner"
      :partnerStatus="partnerStatus"
      :unavailabilityRate="unavailabilityRate"
      :campaignStatus="status"
      :campaignType="campaignType"
      :budgetPercentage="budgetPercentage"
      :isActionable="false"
      :hasHint="false"
      :isSmall="true"
    />
    <CampaignBudgetCard
      class="tw:w-full tw:lg:w-1/3 tw:flex-shrink-0"
      v-if="campaignType === 'cpc'"
      :budgetPercentage="budgetPercentage"
      :budget="budget"
      :partnerStatus="partnerStatus"
      :campaignStatus="status"
      :isActionable="false"
      :hasHint="false"
      :isSmall="true"
    />
    <CampaignCommissionCard
      class="tw:w-full tw:lg:w-1/3 tw:flex-shrink-0"
      v-if="campaignType === 'netCpa'"
      :cpa="campaignsData?.cpa"
      :isActionable="false"
      :hasHint="false"
      :isSmall="true"
      :partnerStatus="partnerStatus"
      :campaignStatus="status"
      :unavailabilityRate="unavailabilityRate"
    />
  </div>
</template>
<script setup>
import { computed } from 'vue'

import CampaignStatusCard from '@/components/rateConnect/statusBar/CampaignStatusCard.vue'
import ConnectivityProviderCard from '@/components/rateConnect/statusBar/ConnectivityProviderCard.vue'
import CampaignCommissionCard from '@/components/rateConnect/statusBar/CampaignCommissionCard.vue'
import CampaignBudgetCard from '@/components/rateConnect/statusBar/CampaignBudgetCard.vue'

import { useBudget, useCampaign, useCompetitivenessStats, usePartners } from '@/components/rateConnect/queries'
import { selectedAccommodationId } from '@/layouts/queries'

const { campaignsData, currentPartner } = useCampaign(selectedAccommodationId)
const { partnersData } = usePartners(selectedAccommodationId)
const { competitivenessStats } = useCompetitivenessStats(selectedAccommodationId)
const campaignType = computed(() => campaignsData.value?.campaignType)
const { budget } = useBudget({ accommodationId: selectedAccommodationId, campaignType })
const currentRCPartner = computed(() => partnersData.value?.find(item => item.partnerId === currentPartner.value))
const partnerStatus = computed(() =>
  currentRCPartner.value?.partnerStatus === 5 && currentRCPartner.value?.connectionStatus === 5 ? 'active' : 'inactive'
)
const status = computed(() => campaignsData.value?.status)

const unavailabilityRate = computed(() => {
  if (competitivenessStats.value?.unavailabilityShare === null) {
    return '-'
  } else {
    const sum =
      Math.round(competitivenessStats.value?.beatShare) +
      Math.round(competitivenessStats.value?.meetShare) +
      Math.round(competitivenessStats.value?.loseShare) +
      Math.round(competitivenessStats.value?.unavailabilityShare)

    if (sum > 100) {
      return Math.round(competitivenessStats.value?.unavailabilityShare) - 1
    } else if (sum < 100) {
      return Math.round(competitivenessStats.value?.unavailabilityShare) + 1
    } else {
      return Math.round(competitivenessStats.value?.unavailabilityShare)
    }
  }
})

const budgetPercentage = computed(() => {
  if (!budget.value?.limit || budget.value.limit === 0) {
    return 0
  }
  const percentage = Math.round((budget.value?.left / budget.value?.limit) * 100)
  return percentage
})
</script>
